import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ModalOutlet } from './components/modal-outlet/modal-outlet';
import { ToastOutlet } from './components/toast-outlet/toast-outlet';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ModalOutlet, ToastOutlet],
  template: `
    <router-outlet />
    <app-modal-outlet />
    <app-toast-outlet />
  `,
  styles: [`:host { display: block; height: 100vh; overflow: hidden; }`],
})
export class App {}
